var Model = require('../../libs/Model');

var IncludesRecord = Object.create(Model);

IncludesRecord.name = 'IncludesRecord';
IncludesRecord['@class'] = 'IncludesRecord';
IncludesRecord.url = 'includesrecord';

IncludesRecord.fields = {
  out: {
    validators: {
      presence: true
    }
  },
  in: {
    validators: {
      presence: true
    }
  },
  index: {}
};

module.exports = IncludesRecord;
